import { Box, Button, Modal, Stack, Typography } from "@mui/material";

const approveModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 10,
  borderRadius: "10px",
  p: 2
};

export default function ConfirmationModal({
  confirmationModal,
  setConfirmationModal,
  setIsConfirmed,
  message
}) {
  return (
    <>
      <Modal open={confirmationModal} onClose={() => setConfirmationModal(false)}>
        <Box sx={approveModalStyle}>
          <Typography variant="h6" textAlign="center">
            {message}
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
            <Button
              variant="contained"
              className="btn btn-primary"
              onClick={async () => {
                setIsConfirmed(true);
                setConfirmationModal(false);
              }}
            >
              Yes
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setIsConfirmed(false);
                setConfirmationModal(false);
              }}
            >
              No
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
}
